import type { GetEventsParams } from '@vlabs/api/luna-api/model';

import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

export type EventListFilters = GetEventsParams & {
  card_ids?: string[];
  top_similar_card_ids?: string[];
};

const [
  useEventListFilters,
  EventListFiltersProvider,
] = createGenericFiltersContext<EventListFilters>({
  displayName: 'EventListFilters',
});

export {
  useEventListFilters,
  EventListFiltersProvider,
};
